
<template>
  <div class="sub-route">
    <section class="app-section login">
      <img class="login-back" src="../../images/login_back.png" />
      <div class="login-wrapper">
        <div class="login-container" style="color: #fff;font-size: 26px;text-align: center;">
          {{t == 1850 ? '中国医学科学院肿瘤医院' : '全病程管理'}}
          <!-- <div class="login-content">
            <Input
              size="large"
              prefix="md-person"
              placeholder="请输入手机号"
              style="margin-top: 40px"
              autofocus
              v-model="username"
              @keyup.enter.native="submit"
            />
            <Input
              size="large"
              prefix="ios-lock"
              type="password"
              placeholder="请输入密码"
              style="margin-top: 20px"
              v-model="password"
              @keyup.enter.native="submit"
            />
            <Button size="large" type="primary" :loading="loading" long style="margin-top: 35px" @click="submit">登录</Button>
          </div> -->
          <el-card style="margin-top: 30px;padding: 20px;border-radius: 12px">
            <el-form :model="form" ref="formRef" :rules="rules">
              <el-form-item prop="username">
                <el-input v-model.trim="form.username" placeholder="请输入手机号"/>
              </el-form-item>
              <el-form-item v-show="!flag" prop="password">
                <el-input v-model.trim="form.password" placeholder="请输入密码" show-password/>
              </el-form-item>
              <el-form-item v-show="flag" prop="code">
                <el-input placeholder="请输入验证码" v-model.trim="form.code" prefix-icon="">
                  <template slot="append">
                    <el-button class="code-btn" type="text" size="medium" :loading="codeLoading" style="margin: 0 2px" @click="sendCode">
                      {{ time >= 1 ? (time + '秒后重新发送') : '发送验证码'}}
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
              <div style="text-align: right;font-size: 14px;margin-top: -10px">
                <el-button type="text" @click="toggleFlag">{{flag ? '密码登录？' : '验证码登录？'}} </el-button>
              </div>
              <el-button style="width: 100%;margin-top:10px" type="primary" :loading="loading" @click="submit">登录</el-button>
            </el-form>
          </el-card>
        </div>
        <footer v-if="t != 1850">
          <a href="http://www.yuanxinyiliao.com" target="_blank">北京圆心医疗科技有限公司</a>
          提供技术支持 &copy;&nbsp;All Right Reserved.
        </footer>
      </div>
    </section>
  </div>
</template>

<script>
import md5 from 'md5';
import storage from 'store';
import { fetchAddressBookListApi } from "../../utils/addressBook"
import { getImTokenApi } from "../../api/common";
import { sendUserCodeApi } from "../../api/user"
import { TENANT, IS_PLATFORM } from '../../utils/env'
import { setDocumentTitle } from '../../utils/domUtil'
export default {
  name: 'login',
  data: function () {
    return {
      username: '',
      password: '',
      form: {
        username: "",
        code: "",
        password: ""
      },
      loading: false,
      t: '',
      flag: false,
      codeLoading: false,
      time: 0
    }
  },
  computed: {
    rules() {
      if (this.flag) {
        return {
          username: [
            {
              required: true,
              message: "请输入手机号",
              trigger: "blur",
            },
            {
              required: true,
              message: "请输入手机号",
              trigger: "change",
            },
          ],
          code: [
            {
              required: true,
              message: "请输入验证码",
              trigger: "blur",
            },
            {
              required: true,
              message: "请输入验证码",
              trigger: "change",
            },
          ],
        }
      }
      return {
        username: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            required: true,
            message: "请输入手机号",
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            required: true,
            message: "请输入密码",
            trigger: "change",
          },
        ]
      }
    }
  },
  created() {
    console.log(process.env.VUE_APP_HOSPITAL_CODE, "CARING_HOSPITAL_CODE", "CARING_API_PATH")
    this.t = process.env.NODE_ENV === 'development' ? 'prm.chinacaring.com'.split('.')[0] : location.host.split('.')[0];
    // this.t = process.env.NODE_ENV === 'development' ? '1000.chinacaring.com'.split('.')[0] : location.host.split('.')[0];
    if (this.t !== 'prm') {
      this.$store.commit('setPlatform', false)
      storage.set(IS_PLATFORM, false)
    } else {
      this.$store.commit('setPlatform', true)
      storage.set(IS_PLATFORM, true)
    }
  },
  methods: {
    submit() {
      this.$refs.formRef.validate((vaild) => {
        if (vaild) {
          const { username, password, code } = this.form
          this.loading = true;
          let loginData = {};
          if (this.flag) {
            loginData = {
              phone: username,
              code,
              role: "doctor",
              device_id: "1",
              device_name: "1",
              device_version: '1',
            }
          } else {
            loginData = {
              username,
              password: md5(password),
              grant_type: 'password',
              role: "doctor"
            }
          }
          let { t } = this;
          let url;
          if (process.env.VUE_APP_HOSPITAL_CODE && (process.env.VUE_APP_HOSPITAL_CODE !== " ".trim()) && (process.env.VUE_APP_HOSPITAL_CODE !== ("CARING_1_HOSPITAL_CODE".split("_1").join("")))) {
            url = process.env.VUE_APP_HOSPITAL_CODE;
          }
          t = url || t
          if (t !== 'prm') {
            loginData.tenant = t;
          }
          this.$store.dispatch('Login', loginData).then(
            ({ data: res }) => {
              if (t !== 'prm') {
                res.user.tenants = [{
                  tenant: t,
                  remake: '全病程管理'
                }]
              }
              if (res.user.tenants && res.user.tenants.length == 1) {
                this.$store.commit('setTenant', res.user.tenants[0]);
                setDocumentTitle(res.user.tenants[0].remake);
                storage.set(TENANT + this.$store.state.user.user.id, res.user.tenants[0],7 * 24 * 60 * 60 * 1000);
                fetchAddressBookListApi();
                getImTokenApi().then(res => {
                  if (res.code === 0) {
                    this.$store.commit('setIm', res.data);
                  } else {
                    this.$message.error('获取im接口服务异常!!!');
                  }
                })
                this.$store.dispatch('getShiftListV2').then(
                  () => {
                    this.$router.replace({ name: 'base' })
                  },
                  (res) => {
                    this.$message.error(res.message);
                    this.loading = false;
                    this.$store.dispatch("Logout").finally(() => {
                      this.$router.replace({
                        name: 'login',
                      })
                    })
                  }
                )
              } else {
                this.$router.replace({ name: 'tenants' })
              }
            },
            (fail) => {
              this.$message.error(fail.message);
              this.loading = false
            }
          ).catch(() => {
            this.loading = false
          })
        }
      })
    },
    sendCode() {
      if (!this.form.username) {
        this.$message.warning("请输入手机号！")
        return
      }
      if (this.time >= 1 || this.codeLoading) {
        return
      }
      this.codeLoading = true
      sendUserCodeApi(this.form.username).then((res) => {
        this.codeLoading = false
        if (res.code === 0) {
          this.$message.success({
            message: '发送验证码成功，请及时查收！',
          });
          this.time = 60;
          this.timer = setInterval(() => {
            this.time--
            if (this.time < 1) {
              clearInterval(this.timer)
            }
          }, 1000)
        } else {
          this.$message.error({
            message: res.message,
          });
        }
      }).catch(() => {
        this.codeLoading = false
      })
    },
    toggleFlag() {
      this.flag = !this.flag;
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate();
      })
    }
  },
}
</script>

<style lang="less">
@import '../../styles/common.less';

.login {
  background-color: @background-color;

  .login-back {
    width: 100%;
    min-height: 50%;
    max-height: 55%;
  }

  .login-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    .login-container {
      position: absolute;
      width: 400px;
      height: 400px;
      top: 55%;
      left: 50%;
      margin-top: -250px;
      margin-left: -400px;

      img {
        width: 400px;
      }

      .login-content {
        padding: 0 40px;
        height: 240px;
        margin-top: 20px;
        box-shadow: 0 2px 8px @border-color;
        background-color: #fff;
        border-radius: 10px;
      }
    }

    footer {
      position: absolute;
      height: 40px;
      line-height: 40px;
      text-align: center;
      left: 0;
      right: 0;
      bottom: 0;
      color: @sub-color;
    }
  }
}
</style>
